


























































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import Fuse from 'fuse.js';
import { IOrder } from '@/service/types';
import * as moment from 'moment';
import { momentLocalized } from '@/plugins/moment';
import {
  State,
  Getter,
  Action,
  Mutation,
  namespace
} from 'vuex-class';
import { locale } from '@/i18n';
// components
import OrdersShippingFilter from '@/views/dashboard/orders/OrdersShippingFilter.vue';
import OrdersDatePicker from '@/views/dashboard/orders/OrdersDatePicker.vue';
import OrdersListHead from '@/views/dashboard/orders/OrdersListHead.vue';
import OrdersListItems from '@/views/dashboard/orders/OrdersListItems.vue';
import OrdersFilterDialog from '@/views/dashboard/orders/OrdersFilterDialog.vue';

interface ISortBy {
  key: string,
  desc: boolean
}

interface IDatePickerModel {
  modal: boolean,
  value: string
}

interface IDateRange {
  from: IDatePickerModel,
  to: IDatePickerModel
}

const initDateRange = {
  from: {
    modal: false,
    value: momentLocalized().format('YYYY-MM-DD')
  },
  to: {
    modal: false,
    value: momentLocalized().format('YYYY-MM-DD')
  }
}

@Component({
  components: {
    OrdersShippingFilter,
    OrdersDatePicker,
    OrdersListHead,
    OrdersListItems,
    OrdersFilterDialog
  }
})
export default class Orders extends Vue {
  // vuex
  @Getter('order/all') all: Array<IOrder>;
  @Getter('order/searchQuery') searchQuery: string;
  @Action('order/updateSearchQuery') updateSearchQuery(v: string|undefined): void {};
  @Action('order/updateOrders') async updateOrders(): Promise<any> {};
  @Getter('getScannerValue') scannerValue: string;
  @Getter('getScanIndex') scanIndex: string;
  @Watch('scanIndex') watchScannerValue(value: string, oldValue: string) {
    console.log(this.scannerValue);
    if (value !== '') {
      this.updateSearchQuery(this.scannerValue);
    }
  }
  @Watch('all') watchAllProducts(value: Array<IOrder>) {
    this.reinitializeFilters();
  }

  // fields
  locale: string|undefined = locale;
  ready: boolean = false;
  sortBy: ISortBy = {
    key: 'date',
    desc: false
  };
  page: number = 1;
  itemsPerPage: number = 10;
  deliveryMethodsSelected: Array<string> = [];
  filteredItemsCount: number = 0;
  date: IDateRange = initDateRange;

  mounted() {
    this.ready = true;
    this.updateOrders();
    this.reinitializeFilters();
  }

  reinitializeFilters() {
    this.deliveryMethodsSelected = [];
    this.initDateRange();
  }
  
  private initDateRange() {
    let min = new Date();
    let max = new Date();
    _.each(this.all, (item) => {
      if (item.date < min) {
        min = _.cloneDeep(item.date);
      } else if (item.date > max) {
        max = _.cloneDeep(item.date);
      }
    });
    this.date.from.value = this.$moment(min).format('YYYY-MM-DD');
    this.date.to.value = this.$moment(max).format('YYYY-MM-DD');
  }

  sort(items: Array<IOrder>): Array<IOrder> {
    // ( 1) - DESC - newest first
    // (-1) - ASC  - oldest first
    const orderWay = this.sortBy.desc ? 1 : -1;
    items.sort((a: IOrder, b: IOrder) => {
      return orderWay * (a.date > b.date ? 1 : (a.date == b.date ? 0 : -1));
    });
    return items;
  }

  filter(items: Array<IOrder>, search: string): Array<IOrder> {
    // iterations
    // 1. by shipping
    let filtered = this.filterByDate(items);
    if (this.deliveryMethodsSelected.length) {
      filtered = this.filterByShippingMethods(filtered);
    }
    if (search && _.isString(search) && search != '') {
      filtered = this.filterBySearchQuery(filtered, search);
    }
    
    this.filteredItemsCount = filtered.length;
    return filtered;
  }

  filterByDate(items: Array<IOrder>): Array<IOrder>  {
    const from: moment.Moment = this.$moment(this.date.from.value);
    from.startOf('day');
    const fromDate: Date = from.toDate();
    const to: moment.Moment = this.$moment(this.date.to.value);
    to.endOf('day');
    const toDate: Date = to.toDate();
    
    return _.filter(items, (item) => {
      return item.date >= fromDate && item.date <= toDate;
    });
  }

  filterByShippingMethods(items: Array<IOrder>): Array<IOrder> {
    return _.filter(items, (item) => {
      return _.indexOf(this.deliveryMethodsSelected, item.shipping) != -1;
    });
  }

  filterBySearchQuery(items: Array<IOrder>, query: string): Array<IOrder> {
    const options = {
      threshold: 0.1,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: [
        "reference"
      ]
    };
    const searchOperation = new Fuse(items, options);
    return searchOperation.search(query);
  }

  // getters

  get countPages() {
    return (filteredCount: number) => {
      return _.ceil(filteredCount / this.itemsPerPage);
    }
  }

  get deliveryMethods() {
    return _.map(_.uniqBy(this.all, 'shipping'), 'shipping'); 
  }

  // breakpoints
  get isCompact() {
    return this.$vuetify.breakpoint.mdAndDown;
  }

}
